import { useEffect, useState } from "react"
import { FaBox, FaCalendar, FaDollarSign, FaUser } from "react-icons/fa"
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { toast } from "react-toastify"
import { CircularProgress } from "@mui/material";
import DinamicButton from "../components/ui/components/DinamicButton"
import FilterButton from "../components/ui/components/FilterButton"
import SearchBar from "../components/ui/components/SearchBar"
import Selector from "../components/ui/components/Selector"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import Modal from "../components/ui/Modal"
import AddIcon from "@mui/icons-material/Add"
import FilterHeadersDialog from "../components/dialogs/FilterHeadersDialog"
import InputFormValue from "../components/ui/components/InputFormValue"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import SaveIcon from "@mui/icons-material/Save"
// import { CategoriasCompras, SubcategoriasCompras } from "../utils/plainValues/ClasificacionCompras"
import { months, years } from "../utils/rawData/dateValues"
import ItemRowRegistroCompraStakeholders from "../components/registroCompras/ItemRowRegistroCompraStakeholders"
import { FormatDateString } from "../utils/FormatDate"
import ParseNumberToFloat from "../utils/helpers/ParseNumberToFloat"
import TiposProducto from "../utils/plainValues/TiposProducto";
import PaginationItem from "../components/ui/components/Pagination";

const ComprasStakeholders = () => {
  const [search, setSearch] = useState("")
  const [limit, setLimit] = useState(20)
  const [page, setPage] = useState(1)

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  
  const [loadingStatus, setLoadingStatus] = useState(false)

  const [record, setRecord] = useState([])
  const [stakeholders, setStakeholders] = useState([])
  const [products, setProducts] = useState([])
  // const [selectedStakeholderOpt, setSelectedStakeholderOpt] = useState(null)

  const [headersTableActive, setHeadersTableActive] = useState([])
  const [openFilter, setOpenFilter] = useState(false)

  const [uploadingStatus, setUploadingStatus] = useState(false)

  const [categories, setCategories] = useState([])
  const [subcategories, setSubcategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("")
  const [selectedSubcategory, setSelectedSubcategory] = useState("")
  const [selectedMonth, setSelectedMonth] = useState("")
  const [selectedYear, setSelectedYear] = useState("")
  const [productType, setProductType] = useState("")

  const getRecord = async () => {
    try {
      setLoadingStatus(true)
      let url = `${BACKEND}/api/comprasStakeholders?limit=${limit}&depth=2&page=${page}`
      if (search) url += `&where[stakeholderProduct.name][like]=${search}`
      if (selectedCategory) url += `&where[stakeholderProduct.category][equals]=${selectedCategory}`
      if (selectedSubcategory) url += `&where[stakeholderProduct.subcategory][equals]=${selectedSubcategory}`
      if (selectedMonth) url += `&where[month][equals]=${selectedMonth}`
      if (selectedYear) url += `&where[year][equals]=${selectedYear}`
      if (productType) url += `&where[stakeholderProduct.type][equals]=${productType}`
      const response = await axios.get(url)
      setRecord(response.data.docs || [])
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las compras")
    } finally {
      setLoadingStatus(false)
    } 
  }

  const getStakeholders = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/stakeholders?limit=0`)
      setStakeholders(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los stakeholders: " + error)
    }
  }

  const getProductsForStakeholder = async (stakeholderId) => {
    if (!stakeholderId) { setProducts([]); return }
    try {
      const response = await axios.get(`${BACKEND}/api/stakeholdersProducts?limit=0&where[stakeholder][equals]=${stakeholderId}`)
      setProducts(response.data.docs || [])
    } catch (e) {
      console.log(e)
      toast.error("Error al obtener productos del stakeholder")
    }
  }

  const getCategories = async () => { // Categorías
    try {
      let url = `${BACKEND}/api/stakeholdersProductsCategories?limit=0`
      const response = await axios.get(url)
      setCategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las categorías: " + error)
    }
  }

  const getSubcategories = async () => { // Subcategorías
    try {
      let url = `${BACKEND}/api/stakeholderProductsSubcategories?limit=0`
      if (selectedCategory) url += `&where[category][equals]=${selectedCategory}`
      const response = await axios.get(url)
      console.log(response)
      setSubcategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las subcategorías: " + error)
    }
  }
  
  useEffect(() => {
    getCategories()
  }, [])

  useEffect(() => {
    if (selectedCategory) {
      getSubcategories()
    } else {
      setSelectedSubcategory("")
      setSubcategories([])
    }
  }, [selectedCategory])
  
  const headers = [
    { id: 1, name: "Acciones", value: "actions", show: true },
    { id: 2, name: "Fecha de emisión", value: "emissionDate", show: true, formatter: (v) => FormatDateString(v) },
    { id: 3, name: "RUC", value: "stakeholder.ruc", show: true },
    { id: 4, name: "Proveedor", value: "stakeholder", show: true, formatter: (v) => ((v?.commercialName || v?.socialReason) ?? "-") },
    { id: 5, name: "Item", value: "stakeholderProduct.name", show: true },
    { id: 6, name: "Descripción", value: "description", show: true },
    { id: 7, name: "Tipo de producto", value: "stakeholderProduct.type", show: true},
    { id: 8, name: "Tipo de comprobante", value: "docType", show: true },
    { id: 9, name: "N° de comprobante", value: "receiptNumber", show: true },
    { id: 10, name: "Subtotal", value: "subtotal", show: true, formatter: (v, row) => ParseNumberToFloat({ number: v, currency: row?.currency }) || "-" },
    { id: 11, name: "IGV", value: "igv", show: true, formatter: (v, row) => ParseNumberToFloat({ number: v, currency: row?.currency }) || "-" },
    { id: 12, name: "Importe total", value: "total", show: true, formatter: (v, row) => ParseNumberToFloat({ number: v, currency: row?.currency }) || "-" },
    { id: 13, name: "Comprobante de transacción", value: "images", show: true },
    { id: 14, name: "Documentos de venta", value: "docuemnt", show: true },
    { id: 15, name: "Estado de pago", value: "paymentStatus", show: true },
    { id: 16, name: "Fecha de pago", value: "paymentDate", show: true, formatter: (v) => FormatDateString(v) },
    { id: 17, name: "Tipo de pago", value: "paymentType", show: true },
    { id: 18, name: "Moneda", value: "currency", show: true, formatter: (v) => v || "-" },
    { id: 19, name: "Categoría", value: "stakeholderProduct.category.categoryName", show: true },
    { id: 20, name: "Subcategoría", value: "stakeholderProduct.subcategory.subcategoryName", show: true },
    { id: 21, name: "Entidad de pago", value: "entity", show: true },
    { id: 22, name: "Costo unitario", value: "unitPrice", show: true, formatter: (v, row) => ParseNumberToFloat({ number: v, currency: row?.currency }) || "-" },
    { id: 23, name: "Cantidad de items", value: "quantity", show: true, formatter: (v) => v || "-" },
    { id: 24, name: "Tipo de costo", value: "costType", show: true },
  ]

  useEffect(() => {
    const localActiveHeaders = JSON.parse(localStorage.getItem("activeTableColsComprasStakeholders")) || []
    if (localActiveHeaders.length > 0) {
      const sanitized = localActiveHeaders
        .filter((stored) => headers.some((h) => h.id === stored.id))
        .map((stored) => {
          const current = headers.find((h) => h.id === stored.id)
          return { ...current, show: stored.show ?? current.show }
        })
      const missing = headers.filter((h) => !sanitized.some((s) => s.id === h.id))
      const merged = [...sanitized, ...missing]
      setHeadersTableActive(merged)
      localStorage.setItem("activeTableColsComprasStakeholders", JSON.stringify(merged))
    } else setHeadersTableActive(headers)
  }, [])

  useEffect(() => {
    if (search === "") {
      getRecord()
      setPage(1)
    }
  }, [search])

  useEffect(() => {
    if (headersTableActive.length > 0) {
      localStorage.setItem("activeTableColsComprasStakeholders", JSON.stringify(headersTableActive))
    }
  }, [headersTableActive])

  useEffect(() => {
    getRecord()
  }, [limit, page, selectedCategory, selectedSubcategory, selectedMonth, selectedYear, productType])

  useEffect(() => {
    getRecord()
  }, [])

  // Create modal state
  const [createModal, setCreateModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [editPurchase, setEditPurchase] = useState(null)

  useEffect(() => { getStakeholders() }, [])

  // New purchase form
  const [newPurchase, setNewPurchase] = useState({
    stakeholder: "",
    stakeholderProduct: "",
    description: "",
    emissionDate: "",
    paymentDate: "",
    entity: "",
    subtotal: "",
    igv: "",
    total: "",
    category: "",
    subcategory: "",
    receiptNumber: "",
    paymentStatus: "Pendiente",
    currency: "Soles",
    paymentType: "Unico",
    docType: "Boleta",
    costType: "Costo fijo",
    numInstallments: 1,
    quantity: 1
  })

  const resetNewForm = () => setNewPurchase({ 
    stakeholder: "", stakeholderProduct: "", total: "",
    description: "", emissionDate: "", paymentDate: "",
    entity: "", subtotal: "", igv: "",
    category: "", subcategory: "", receiptNumber: "",
    paymentStatus: "Pendiente", currency: "Soles", paymentType: "Unico",
    docType: "Boleta", costType: "Costo fijo", numInstallments: 1,
    unitPrice: "", quantity: 1
  })

  useEffect(() => {
    const totalNumber = Number(newPurchase.total) || 0
    if (newPurchase.docType === "Factura") {
      const igvCalc = (totalNumber * 0.18).toFixed(2)
      const subtotalCalc = (totalNumber - Number(igvCalc)).toFixed(2)
      setNewPurchase(prev => ({ ...prev, igv: igvCalc, subtotal: subtotalCalc }))
    } else {
      setNewPurchase(prev => ({ ...prev, igv: 0, subtotal: totalNumber.toFixed(2) }))
    }
  }, [newPurchase.docType, newPurchase.total])

  // Calcular total automáticamente basado en cantidad y precio unitario
  useEffect(() => {
    const quantity = Number(newPurchase.quantity) || 0
    const unitPrice = Number(newPurchase.unitPrice) || 0
    const calculatedTotal = (quantity * unitPrice).toFixed(2)
    if (calculatedTotal !== newPurchase.total) {
      setNewPurchase(prev => ({ ...prev, total: calculatedTotal }))
    }
  }, [newPurchase.quantity, newPurchase.unitPrice])

  const SubmitPurchase = async () => {
    try {
      if (!newPurchase.stakeholder || !newPurchase.stakeholderProduct || !newPurchase.total ) {
        toast.error("Completa todos los campos obligatorios")
        return
      }
      if (!newPurchase.paymentDate) {
        toast.error("Selecciona la fecha de pago")
        return
      }

      setUploadingStatus(true)
      
      const basePayload = {
        stakeholder: newPurchase.stakeholder,
        stakeholderProduct: newPurchase.stakeholderProduct,
        total: Number(newPurchase.total),
        description: newPurchase.description || undefined,
        emissionDate: newPurchase.emissionDate || undefined,
        // paymentDate se calculará abajo
        entity: newPurchase.entity || undefined,
        subtotal: newPurchase.subtotal !== "" ? Number(newPurchase.subtotal) : undefined,
        igv: newPurchase.igv !== "" ? Number(newPurchase.igv) : undefined,
        category: newPurchase.category || undefined,
        subcategory: newPurchase.subcategory || undefined,
        receiptNumber: newPurchase.receiptNumber || undefined,
        paymentStatus: newPurchase.paymentStatus || undefined,
        currency: newPurchase.currency || undefined,
        paymentType: newPurchase.paymentType || undefined,
        docType: newPurchase.docType || undefined,
        costType: newPurchase.costType || undefined,
        unitPrice: newPurchase.unitPrice !== "" ? Number(newPurchase.unitPrice) : undefined,
        quantity: newPurchase.quantity !== "" ? Number(newPurchase.quantity) : undefined,
        // quoteNumber se calculará abajo
      }

      const parsePaymentBaseDate = () => {
        try {
          return new Date(newPurchase.paymentDate + 'T00:00:00-05:00')
        } catch (e) {
          return null
        }
      }

      const parseEmissionBaseDate = () => {
        try {
          return new Date(newPurchase.emissionDate + 'T00:00:00-05:00')
        } catch (e) {
          return null
        }
      }

      const getPaymentDateByIndex = (i) => {
        const d = parsePaymentBaseDate()
        if (!d || isNaN(d.getTime())) return null
        const day = d.getDate()
        const month = d.getMonth()
        const year = d.getFullYear()
        let next
        switch (newPurchase.paymentType) {
          case "Diario":
            next = new Date(year, month, day + i)
            break
          case "Semanal":
            next = new Date(year, month, day + i * 7)
            break
          case "Quincenal":
            next = new Date(year, month, day + i * 15)
            break
          case "Mensual":
            next = new Date(year, month + i, day)
            break
          case "Bimestral":
            next = new Date(year, month + i * 2, day)
            break
          case "Trimestral":
            next = new Date(year, month + i * 3, day)
            break
          case "Cuatrimestral":
            next = new Date(year, month + i * 4, day)
            break
          case "Semestral":
            next = new Date(year, month + i * 6, day)
            break
          case "Anual":
            next = new Date(year + i, month, day)
            break
          case "Unico":
          default:
            next = new Date(year, month, day)
            break
        }
        return next
      }

      const getEmissionDateByIndex = (i) => {
        const d = parseEmissionBaseDate()
        if (!d || isNaN(d.getTime())) return null
        const day = d.getDate()
        const month = d.getMonth()
        const year = d.getFullYear()
        let next
        switch (newPurchase.paymentType) {
          case "Diario":
            next = new Date(year, month, day + i)
            break
          case "Semanal":
            next = new Date(year, month, day + i * 7)
            break
          case "Quincenal":
            next = new Date(year, month, day + i * 15)
            break
          case "Mensual":
            next = new Date(year, month + i, day)
            break
          case "Bimestral":
            next = new Date(year, month + i * 2, day)
            break
          case "Trimestral":
            next = new Date(year, month + i * 3, day)
            break
          case "Cuatrimestral":
            next = new Date(year, month + i * 4, day)
            break
          case "Semestral":
            next = new Date(year, month + i * 6, day)
            break
          case "Anual":
            next = new Date(year + i, month, day)
            break
          case "Unico":
          default:
            next = new Date(year, month, day)
            break
        }
        return next
      }

      const num = Math.max(1, Number(newPurchase.numInstallments) || 1)

      if (newPurchase.paymentType === "Unico" || num === 1) {
        const dPay = getPaymentDateByIndex(0)
        const dEmi = getEmissionDateByIndex(0)
        if (!dPay || !dEmi) {
          toast.error("Fecha de pago inválida")
          return
        }
        const payload = {
          ...basePayload,
          paymentDate: dPay.toISOString(),
          emissionDate: dEmi.toISOString(),
          quoteNumber: `1/1`,
        }
        await axios.post(`${BACKEND}/api/comprasStakeholders`, payload)
      } else {
        for (let i = 0; i < num; i++) {
          const dPay = getPaymentDateByIndex(i)
          const dEmi = getEmissionDateByIndex(i)
          if (!dPay || !dEmi) continue
          const payload = {
            ...basePayload,
            paymentDate: dPay.toISOString(),
            emissionDate: dEmi.toISOString(),
            quoteNumber: `${i + 1}/${num}`,
          }
          await axios.post(`${BACKEND}/api/comprasStakeholders`, payload)
        }
      }

      toast.success("Compra registrada correctamente")
      setCreateModal(false)
      resetNewForm()
      // setSelectedStakeholderOpt(null)
      setProducts([])
      getRecord()
    } catch (e) {
      console.log(e)
      toast.error("Error al registrar la compra")
    } finally {
      setUploadingStatus(false)
    }
  }

  const openEditPurchase = (purchase) => {
    setEditPurchase({
      id: purchase.id,
      stakeholder: purchase.stakeholder?.id || purchase.stakeholder,
      stakeholderProduct: purchase.stakeholderProduct?.id || purchase.stakeholderProduct,
      total: purchase.total ?? "",
      description: purchase.description ?? "",
      emissionDate: purchase.emissionDate ? String(purchase.emissionDate).slice(0,10) : "",
      paymentDate: purchase.paymentDate ? String(purchase.paymentDate).slice(0,10) : "",
      entity: purchase.entity ?? "",
      subtotal: purchase.subtotal ?? "",
      igv: purchase.igv ?? "",
      category: purchase.category ?? "",
      subcategory: purchase.subcategory ?? "",
      receiptNumber: purchase.receiptNumber ?? "",
      paymentStatus: purchase.paymentStatus ?? "Pendiente",
      currency: purchase.currency ?? "Soles",
      paymentType: purchase.paymentType ?? "Unico",
      docType: purchase.docType ?? "Boleta",
      costType: purchase.costType ?? "Costo fijo",
      unitPrice: purchase.unitPrice ?? "",
      quantity: purchase.quantity ?? "",
    })
    // const opt = purchase.stakeholder ? { value: purchase.stakeholder.id || purchase.stakeholder, label: (purchase.stakeholder.commercialName || purchase.stakeholder.socialReason) } : null
    // setSelectedStakeholderOpt(opt)
    getProductsForStakeholder(purchase.stakeholder?.id || purchase.stakeholder)
    setEditModal(true)
  }

  // Calcular total automáticamente para el formulario de edición
  useEffect(() => {
    if (editPurchase && (editPurchase.quantity !== undefined || editPurchase.unitPrice !== undefined)) {
      const quantity = Number(editPurchase.quantity) || 0
      const unitPrice = Number(editPurchase.unitPrice) || 0
      const calculatedTotal = (quantity * unitPrice).toFixed(2)
      if (calculatedTotal !== editPurchase.total) {
        setEditPurchase(prev => ({ ...prev, total: calculatedTotal }))
      }
    }
  }, [editPurchase?.quantity, editPurchase?.unitPrice])

  useEffect(() => {
    if (!editPurchase) return
    const totalNumber = Number(editPurchase.total) || 0
    if (editPurchase.docType === "Factura") {
      const igvCalc = (totalNumber * 0.18).toFixed(2)
      const subtotalCalc = (totalNumber - Number(igvCalc)).toFixed(2)
      setEditPurchase(prev => ({ ...prev, igv: igvCalc, subtotal: subtotalCalc }))
    } else {
      setEditPurchase(prev => ({ ...prev, igv: 0, subtotal: totalNumber.toFixed(2) }))
    }
  }, [editPurchase?.docType, editPurchase?.total])

  const UpdatePurchase = async () => {
    if (!editPurchase) return
    setUploadingStatus(true)
    try {
      const payload = {
        stakeholder: editPurchase.stakeholder,
        stakeholderProduct: editPurchase.stakeholderProduct,
        total: Number(editPurchase.total),
        description: editPurchase.description || undefined,
        emissionDate: editPurchase.emissionDate || undefined,
        paymentDate: editPurchase.paymentDate || undefined,
        entity: editPurchase.entity || undefined,
        subtotal: editPurchase.subtotal !== "" ? Number(editPurchase.subtotal) : undefined,
        igv: editPurchase.igv !== "" ? Number(editPurchase.igv) : undefined,
        category: editPurchase.category || undefined,
        subcategory: editPurchase.subcategory || undefined,
        receiptNumber: editPurchase.receiptNumber || undefined,
        paymentStatus: editPurchase.paymentStatus || undefined,
        currency: editPurchase.currency || undefined,
        paymentType: editPurchase.paymentType || undefined,
        docType: editPurchase.docType || undefined,
        costType: editPurchase.costType || undefined,
        unitPrice: editPurchase.unitPrice !== "" ? Number(editPurchase.unitPrice) : undefined,
        quantity: editPurchase.quantity !== "" ? Number(editPurchase.quantity) : 1,
      }
      const response = await axios.put(`${BACKEND}/api/comprasStakeholders/${editPurchase.id}`, payload)
      console.log(response)
      toast.success("Compra actualizada correctamente")
      setEditModal(false)
      setEditPurchase(null)
      setProducts([])
      getRecord()
    } catch (e) {
      console.log(e)
      toast.error("Error al actualizar la compra")
    } finally {
      setUploadingStatus(false)
    }
  }

  const DeletePurchase = async (id) => {
    try {
      const confirm = window.confirm("¿Eliminar esta compra?")
      if (!confirm) return
      await axios.delete(`${BACKEND}/api/comprasStakeholders/${id}`)
      toast.success("Compra eliminada")
      getRecord()
    } catch (e) {
      console.log(e)
      toast.error("Error al eliminar la compra")
    }
  }

  return (
    <div className="flex flex-col h-screen w-full">

      <FilterHeadersDialog
        activeCols={headersTableActive}
        localStorageKey="activeTableColsComprasStakeholders"
        defaultCols={headers}
        open={openFilter}
        setOpen={setOpenFilter}
        setActiveCols={setHeadersTableActive}
      />

      <Modal // Modal para registrar compra
        activeModal={createModal}
        onClose={() => {
          setCreateModal(false)
          resetNewForm()
          setProducts([])
        }}
        title="Registrar compra"
        className="max-w-3xl"
        centered
      >
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            <InputFormValue
              title="Proveedor"
              info="Selecciona el stakeholder proveedor"
              icon={<FaUser />}
              value={newPurchase.stakeholder}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, stakeholder: value }))}
              required
              minChars={0}
              type="autocomplete"
              options={stakeholders.map((s) => ({ value: s.id, label: s.commercialName || s.socialReason }))}
              onSelectOption={(opt) => { 
                setNewPurchase(prev => ({ ...prev, stakeholder: opt?.value || "", stakeholderProduct: "" })); 
                getProductsForStakeholder(opt?.value) 
              }}
              placeholder="Buscar proveedor..."
            />
            <InputFormValue
              title="Ítem"
              info="Producto del stakeholder seleccionado"
              icon={<FaBox />}
              value={newPurchase.stakeholderProduct}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, stakeholderProduct: value }))}
              required
              minChars={0}
              type="autocomplete"
              options={products.map((p) => ({ value: p.id, label: p.name }))}
              disabled={!newPurchase.stakeholder}
              onSelectOption={(opt) => { 
                setNewPurchase(prev => ({ ...prev, unitPrice: products.find(p => p.id === opt?.value)?.price || 0 })) 
                setNewPurchase(prev => ({ ...prev, currency: products.find(p => p.id === opt?.value)?.currency || "Soles" }))
              }}
              placeholder="Buscar ítem..."            
            />
            <InputFormValue
              title="Tipo de documento"
              icon={<FaBox />}
              value={newPurchase.docType}
              required
              setValue={(value) => setNewPurchase(prev => ({ ...prev, docType: value }))}
              type="select"
              options={[
                { label: "Factura", value: "Factura" },
                { label: "Boleta", value: "Boleta" },
                { label: "RH", value: "RH" },
                { label: "Proforma", value: "Proforma" },
                { label: "Nota de credito", value: "Nota de credito" },
                { label: "Nota de debito", value: "Nota de debito" },
                { label: "Ticket", value: "Ticket" },
                { label: "POS", value: "POS" },
                { label: "Recibo", value: "Recibo" },
              ]}
            />
            <InputFormValue
              title="Moneda"
              icon={<FaBox />}
              value={newPurchase.currency}
              required
              setValue={(value) => setNewPurchase(prev => ({ ...prev, currency: value }))}
              type="select"
              options={[
                { label: "Soles", value: "Soles" },
                { label: "Dolares", value: "Dolares" },
              ]}
            />
            <InputFormValue
              title="Costo unitario"
              info="Precio por unidad del producto"
              icon={<AttachMoneyIcon />}
              required
              value={newPurchase.unitPrice}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, unitPrice: value }))}
              type="number"
              placeholder="0.00"
            />
            <InputFormValue
              title="Cantidad de items"
              info="Número de unidades compradas"
              icon={<FaBox />}
              required
              value={newPurchase.quantity}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, quantity: value }))}
              type="number"
              min={1}
              placeholder="1"
            />
            <InputFormValue
              title="Total"
              info="Monto total calculado automáticamente (Cantidad × Precio unitario)"
              icon={<FaDollarSign />}
              value={newPurchase.total}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, total: value }))}
              required
              type="number"
              placeholder="0.00"
              disabled
            />
            <InputFormValue
              title="Subtotal"
              info="El subtotal se calcula en función al total de la compra y si es una factura"
              icon={<FaDollarSign />}
              value={newPurchase.subtotal}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, subtotal: value }))}
              type="number"
              required
              placeholder="0.00"
              disabled
            />
            <InputFormValue
              title="IGV"
              info="El IGV se calcula en función al total de la compra y si es una factura"
              icon={<FaDollarSign />}
              disabled
              placeholder={newPurchase.docType === "Factura" ? "0.00" : "No aplica"}
              value={newPurchase.docType === "Factura" ? (Number(newPurchase.igv) || 0).toString() : "No aplica"}
              type="number"
            />
            <InputFormValue
              title="Entidad"
              icon={<FaBox />}
              value={newPurchase.entity}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, entity: value }))}
              type="select"
              required
              options={[
                { label: "Seleccionar", value: "" },
                { label: "BCP", value: "BCP" },
                { label: "Interbank", value: "Interbank" },
                { label: "Scotiabank", value: "Scotiabank" },
                { label: "BBVA", value: "BBVA" },
              ]}
            />
            <InputFormValue
              title="Tipo de pago"
              icon={<FaBox />}
              value={newPurchase.paymentType}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, paymentType: value }))}
              type="select"
              required
              options={[
                { value: "Unico", label: "Unico" },
                { value: "Diario", label: "Diario" },
                { value: "Semanal", label: "Semanal" },
                { value: "Quincenal", label: "Quincenal" },
                { value: "Mensual", label: "Mensual" },
                { value: "Bimestral", label: "Bimestral" },
                { value: "Trimestral", label: "Trimestral" },
                { value: "Cuatrimestral", label: "Cuatrimestral" },
                { value: "Semestral", label: "Semestral" },
                { value: "Anual", label: "Anual" },
              ]}
            />
            <InputFormValue
              title="Cuotas/periodos a pagar"
              info="Número de cuotas/periodos a generar según el tipo de pago. Ejemplo: Si el tipo de pago es quincenal y el numero de cuotas/periodos es 6, se generaran 6 pagos cada 15 dias empezando desde la fecha de pago."
              icon={<FaBox />}
              value={newPurchase.numInstallments}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, numInstallments: value }))}
              type="number"
              min={1}
              placeholder="1"
              required
            />
            <InputFormValue
              title="Fecha de emisión"
              icon={<FaCalendar />}
              value={newPurchase.emissionDate}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, emissionDate: value }))}
              type="date"
              required
            />
            <InputFormValue
              title="Fecha de pago"
              icon={<FaCalendar />}
              value={newPurchase.paymentDate}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, paymentDate: value }))}
              type="date"
              required
            />
            <InputFormValue
              title="N° de comprobante"
              icon={<FaBox />}
              value={newPurchase.receiptNumber}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, receiptNumber: value }))}
              type="text"
              placeholder="000-000"
            />
            <InputFormValue
              title="Tipo de costo"
              icon={<FaBox />}
              value={newPurchase.costType}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, costType: value }))}
              type="select"
              options={[
                { label: "Costo fijo", value: "Costo fijo" },
                { label: "Costo variable", value: "Costo variable" },
              ]}
              required
            />  
            <InputFormValue
              title="Descripción"
              info="Detalle de la compra"
              icon={<FaBox />}
              value={newPurchase.description}
              setValue={(value) => setNewPurchase(prev => ({ ...prev, description: value }))}
              type="textarea"
              placeholder="Descripción..."
            />
          </div>
          <div className="flex w-full justify-center items-center gap-2 mt-2">
            <DinamicButton
              action={() => { setCreateModal(false); resetNewForm(); setProducts([]) }}
              content="Cancelar"
              backgroundColor="#6b7280"
              hoverBackgroundColor="#4b5563"
              width="50%"
            />
            <DinamicButton
              action={SubmitPurchase}
              disabled={uploadingStatus}
              content="Registrar compra"
              icon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <AddIcon size={14} />}
              width="50%"
            />
          </div>
        </div>
      </Modal>

      <Modal // Modal para editar compra
        activeModal={editModal}
        onClose={() => { setEditModal(false); setEditPurchase(null); setProducts([]) }}
        title="Editar compra"
        className="max-w-3xl"
        centered
      >
        {!!editPurchase && (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <InputFormValue
                title="Proveedor"
                info="No puedes editar el proveedor de la compra"
                icon={<FaUser />}
                value={editPurchase.stakeholder}
                disabled
                // setValue={(value) => setEditPurchase(prev => ({ ...prev, stakeholder: value }))}
                required
                minChars={2}
                type="autocomplete"
                options={stakeholders.map((s) => ({ value: s.id, label: s.commercialName || s.socialReason }))}
                // onSelectOption={(opt) => { setSelectedStakeholderOpt(opt); setEditPurchase(prev => ({ ...prev, stakeholder: opt?.value || "", stakeholderProduct: "" })); getProductsForStakeholder(opt?.value) }}
                placeholder="Buscar proveedor..."
              />
              <InputFormValue
                title="Ítem"
                info="No puedes editar el ítem de la compra"
                disabled
                icon={<FaBox />}
                value={editPurchase.stakeholderProduct}
                required
                minChars={2}
                type="autocomplete"
                options={products.map((p) => ({ value: p.id, label: p.name }))}
                placeholder="Buscar ítem..."
              />
              <InputFormValue
                title="Tipo de documento"
                icon={<FaBox />}
                value={editPurchase.docType}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, docType: value }))}
                required
                type="select"
                options={[
                  { label: "Factura", value: "Factura" },
                  { label: "Boleta", value: "Boleta" },
                  { label: "RH", value: "RH" },
                  { label: "Proforma", value: "Proforma" },
                  { label: "Nota de credito", value: "Nota de credito" },
                  { label: "Nota de debito", value: "Nota de debito" },
                  { label: "Ticket", value: "Ticket" },
                  { label: "POS", value: "POS" },
                  { label: "Recibo", value: "Recibo" },
                ]}
              />
              <InputFormValue
                title="Moneda"
                icon={<FaBox />}
                value={editPurchase.currency}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, currency: value }))}
                type="select"
                required
                options={[
                  { label: "Soles", value: "Soles" },
                  { label: "Dolares", value: "Dolares" },
                ]}
              />
              <InputFormValue
                title="Costo unitario"
                info="Precio por unidad del producto"
                icon={<AttachMoneyIcon />}
                value={editPurchase.unitPrice}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, unitPrice: value }))}
                type="number"
                required
                placeholder="0.00"
              />
              <InputFormValue
                title="Cantidad de items"
                info="Número de unidades compradas"
                icon={<FaBox />}
                value={editPurchase.quantity}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, quantity: value }))}
                type="number"
                min={1}
                placeholder="1"
                required
              />
              <InputFormValue
                title="Total"
                info="Monto total calculado automáticamente (Cantidad × Precio unitario)"
                icon={<FaDollarSign />}
                value={editPurchase.total}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, total: value }))}
                required
                type="number"
                placeholder="0.00"
                disabled
              />
              <InputFormValue
                title="Subtotal"
                icon={<FaDollarSign />}
                info="El subtotal se calcula en función al total de la compra y si es una factura"
                value={editPurchase.subtotal}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, subtotal: value }))}
                type="number"
                required
                placeholder="0.00"
                disabled
              />
              <InputFormValue
                title="IGV"
                info="El IGV se calcula en función al total de la compra y si es una factura"
                icon={<FaDollarSign />}
                disabled
                placeholder={editPurchase.docType === "Factura" ? "0.00" : "No aplica"}
                value={editPurchase.docType === "Factura" ? (Number(editPurchase.igv) || 0).toString() : "No aplica"}
                type="number"
              />
              <InputFormValue
                title="Fecha de emisión"
                icon={<FaCalendar />}
                value={editPurchase.emissionDate}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, emissionDate: value }))}
                type="date"
                required
              />
              <InputFormValue
                title="Fecha de pago"
                icon={<FaCalendar />}
                value={editPurchase.paymentDate}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, paymentDate: value }))}
                type="date"
                required
              />
              <InputFormValue
                title="Entidad"
                icon={<FaBox />}
                value={editPurchase.entity}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, entity: value }))}
                type="select"
                options={[
                  { label: "Seleccionar", value: "" },
                  { label: "BCP", value: "BCP" },
                  { label: "Interbank", value: "Interbank" },
                  { label: "Scotiabank", value: "Scotiabank" },
                  { label: "BBVA", value: "BBVA" },
                ]}
              />
              <InputFormValue
                title="Estado de pago"
                icon={<FaBox />}
                value={editPurchase.paymentStatus}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, paymentStatus: value }))}
                type="select"
                options={[
                  { label: "Pendiente", value: "Pendiente" },
                  { label: "Pagado", value: "Pagado" },
                ]}
                required
              />
              <InputFormValue
                title="N° de comprobante"
                icon={<FaBox />}
                value={editPurchase.receiptNumber}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, receiptNumber: value }))}
                type="text"
                placeholder="000-000"
              />
              <InputFormValue
                title="Tipo de costo"
                icon={<FaBox />}
                value={editPurchase.costType}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, costType: value }))}
                type="select"
                options={[
                  { label: "Costo fijo", value: "Costo fijo" },
                  { label: "Costo variable", value: "Costo variable" },
                ]}
              />
              <InputFormValue
                title="Descripción"
                info="Detalle de la compra"
                icon={<FaBox />}
                value={editPurchase.description}
                setValue={(value) => setEditPurchase(prev => ({ ...prev, description: value }))}
                type="textarea"
                placeholder="Descripción..."
              />

            </div>
            <div className="flex flex-row gap-4">
              <DinamicButton
                action={() => { setEditModal(false); setEditPurchase(null) }}
                content="Cancelar"
                backgroundColor="#6b7280"
                hoverBackgroundColor="#4b5563"
                width="50%"
              />
              <DinamicButton
                action={UpdatePurchase}
                content="Actualizar compra"
                disabled={uploadingStatus}
                icon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <SaveIcon size={14} />}
                width="50%"
              />
            </div>
          </div>
        )}
      </Modal>

      {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaBox className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Registro de compras</h2>
          </div>
        </div>

        <div className="flex flex-row gap-8 items-center justify-center">

          <Selector
            title="Límite"
            setter={setLimit}
            value={limit}
            width="w-[5rem]"
            options={[
              { value: 20, label: "20" },
              { value: 30, label: "30" },
              { value: 40, label: "40" },
              { value: 50, label: "50" },
              { value: 100, label: "100" },
            ]}
          />

          <SearchBar
            value={search}
            setter={setSearch}
            pageSetter={setPage}
            getter={getRecord}
          />

        </div>

      </div>

      {/* Filtros */}
      <div className="flex flex-row px-4 bg-gray-100 mt-0.5">
        <div className="flex flex-row w-full py-1 items-center gap-4 justify-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row w-full gap-4 items-center justify-center px-6">

            <Selector
              title="Mes"
              setter={setSelectedMonth}
              options={[{ value: "", label: "Todos" }, ...months.map((s) => ({ value: s.value, label: s.label }))]}
              value={selectedMonth}
              width="w-[6rem]"
            />

            <Selector
              title="Año"
              options={[{ value: "", label: "Todos" }, ...years.map((s) => ({ value: s.value, label: s.label }))]}
              value={selectedYear}
              setter={setSelectedYear}
              width="w-[6rem]"
            />

            <Selector
              title="Tipo de producto"
              setter={setProductType}
              options={[{ value: "", label: "Todos" }, ...TiposProducto.map((s) => ({ value: s.value, label: s.label }))]}
              width="w-[8rem]"
              value={productType}
            />

            <Selector
              title="Categoría"
              setter={(val) => { setSelectedCategory(val); setSelectedSubcategory(""); }}
              options={[{ value: "", label: "Todos" }, ...categories.map((s) => ({ value: s.id, label: s.categoryName }))]}
              width="w-[12rem]"
              value={selectedCategory}
            />

            <Selector
              title="Subcategoría"
              options={[{ value: "", label: "Todos" }, ...subcategories.map(s => ({ value: s.id, label: s.subcategoryName }))]}
              value={selectedSubcategory}
              width="w-[12rem]"
              setter={setSelectedSubcategory}
            />
            
            <div className="pl-4">
              <DinamicButton
                content="Registrar compra"
                action={() => setCreateModal(true)}
                icon={<AddIcon />}
              />
            </div>

            <FilterButton
              content="Headers"
              action={() => setOpenFilter(true)}
            />

          </div>
        </div>
      </div>
    
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : (
          record.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                <tr className="text-gray-700 text-center text-xs font-bold">
                  {headersTableActive.filter((h) => h.show).map((h) => {
                    return (
                      <td key={h.id} className="px-4 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                        {h.name}
                      </td>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {record.map((p, i) => {
                  return (
                    <ItemRowRegistroCompraStakeholders
                      key={i}
                      purchase={p}
                      headersTableActive={headersTableActive}
                      headers={headers}
                      openEditPurchase={openEditPurchase}
                      DeletePurchase={DeletePurchase}
                      setter={setRecord}
                    />
                  )
                })}
              </tbody>
            </table>
          )
        )}
      </div>
      
      {/* Paginador */}
      <PaginationItem 
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"compras"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(e, v) => setPage(v)}
      />
    </div>
  )
}

export default ComprasStakeholders